export const whitelistedAttributes = ["target"];

export default whitelistedAttributes;
